@if (showLoadingComponent()) {
  <app-loading-page [isLoading]="isLoading()"></app-loading-page>
}
<router-outlet></router-outlet>
